"use client";
import React, { useState } from "react";
import SleekButton from "../ui/NavButtons";

interface EmailFormProps {
  onSubmit?: (email: string) => void;
  /** Label explaining what users are signing up for (e.g. "Get product updates") */
  label?: string;
}

export const EmailForm: React.FC<EmailFormProps> = ({ onSubmit, label = "Get product updates and early access to new features" }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(email);
    }
    console.log("Email submitted:", email);
  };

  return (
    <div className="w-full max-w-[700px] mx-auto my-0">
      <label
        htmlFor="hero-email"
        className="mb-2 block text-center text-sm font-medium text-gray-800 sm:text-left dark:text-white dark:drop-shadow-[0_1px_2px_rgba(0,0,0,0.65)]"
      >
        {label}
      </label>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col sm:flex-row items-center gap-3 w-full rounded-xl border border-gray-200 dark:border-slate-600 bg-white/80 dark:bg-transparent p-3 sm:p-4 backdrop-blur-sm"
      >
        <input
          id="hero-email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 w-full px-4 py-3 text-sm text-gray-900 dark:text-white bg-transparent rounded-md outline-none placeholder:text-gray-400 dark:placeholder:text-slate-400 sm:text-base"
          required
          aria-label="Email address for product updates"
        />

      {/* Submit Button */}
      <SleekButton variant="primary" type="submit" className="w-full sm:w-auto px-6 sm:px-8 py-3 text-sm sm:text-base font-semibold">
        Subscribe
      </SleekButton>
      </form>
    </div>
  );
};
